let forms = {
	ipfPay: {
		icon: 'fa fa-user',
		title: 'Pay Loan',
		subtitle: 'Pay bank loan',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'amount',
				validation: 'required|min:1|max:150|numeric',
				label: 'Amount',
				placeholder: 'Enter the amount',
			},
		],
	},
	loans_pay: {
		icon: 'fa fa-user',
		title: 'Pay Loan',
		subtitle: 'Pay bank loan',
		forms: [
			{
				type: 'select',
				class: 'col-12 col-md-6 small-margin',
				model: 'payment_option',
				filterable: true,
				clearable: true,
				options: [
					{ val: 'normal', label: 'Normal Payment' },
					{ val: 'principle', label: 'Principle Payment' },
				],
				validation: '',
				label: 'Payment Option',
			},
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12 col-md-6 small-margin',
				model: 'amount',
				validation: 'required|min:1|max:150|numeric',
				label: 'Amount',
				placeholder: 'Enter the amount',
			},
			{
				type: 'textarea',
				class: 'col-12 small-margin',
				model: 'remarks',
				rows: 2,
				filterable: true,
				clearable: true,
				options: [],
				validation: '',
				label: 'Your Payment Remarks (Optional)',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
